function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 22.929688 0.292969 C 11.429688 0.292969 2.128906 9.59375 2.128906 21.09375 C 2.128906 32.59375 11.429688 41.894531 22.929688 41.894531 C 34.429688 41.894531 43.726562 32.59375 43.726562 21.09375 C 43.828125 9.59375 34.429688 0.292969 22.929688 0.292969 Z M 22.929688 38.195312 C 13.527344 38.195312 5.929688 30.59375 5.929688 21.195312 C 5.929688 11.792969 13.527344 4.195312 22.929688 4.195312 C 32.328125 4.195312 39.929688 11.792969 39.929688 21.195312 C 39.929688 30.59375 32.328125 38.195312 22.929688 38.195312 Z M 22.929688 38.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 43.929688 47.792969 C 43.328125 47.792969 42.828125 47.59375 42.429688 47.09375 L 33.929688 36.992188 C 33.226562 36.195312 33.328125 34.894531 34.128906 34.195312 C 34.929688 33.492188 36.226562 33.59375 36.929688 34.394531 L 45.429688 44.492188 C 46.128906 45.292969 46.027344 46.59375 45.226562 47.292969 C 44.828125 47.59375 44.429688 47.792969 43.929688 47.792969 Z M 43.929688 47.792969 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/Search Black.9fd4cf18f0a3782e284e7ed43444c204.svg";
export { ForwardRef as ReactComponent };